import { render, staticRenderFns } from "./ModalAddCampaignDesignation.vue?vue&type=template&id=533dbf96&scoped=true"
import script from "./ModalAddCampaignDesignation.vue?vue&type=script&lang=js"
export * from "./ModalAddCampaignDesignation.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCampaignDesignation.vue?vue&type=style&index=0&id=533dbf96&prod&lang=scss&scoped=true"
import style1 from "./ModalAddCampaignDesignation.vue?vue&type=style&index=1&id=533dbf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533dbf96",
  null
  
)

export default component.exports